import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppContext } from "@/contexts/AppContext";
import { useTenants } from "@/hooks/useTenants";
import { useWorkspaceAudience } from "@/contexts/WorkspaceAudienceContext";

export function useDashboardRouteTenant(tenantId: string | null) {
  const { key } = useLocation();
  const { selectedTenantIds, setSelectedTenantIds } = useAppContext();
  const { audience } = useWorkspaceAudience();
  const { data: tenants = [] } = useTenants();
  const [applied, setApplied] = useState<string | null>(null);
  const signature = `${key}:${tenantId ?? ""}`;
  const authorizedTenant =
    audience.kind === "client-demo"
      ? audience.tenantId
      : tenants.find((tenant) => tenant.tenant_id === tenantId)?.tenant_id;
  const pendingTenant = tenantId && applied !== signature ? authorizedTenant : undefined;

  useEffect(() => {
    if (!pendingTenant) return;
    setSelectedTenantIds([pendingTenant]);
    setApplied(signature);
  }, [pendingTenant, signature, setSelectedTenantIds]);

  return pendingTenant ? [pendingTenant] : selectedTenantIds;
}
